import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CallStatusContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;

const StatusMessage = styled.span`
  color : ${({ textColor }) => textColor || '#4C5863'};
  font-size: 14px;
  font-weight: 400;
  display : flex;
  line-height : 22px;
  
  ${({ isMuted }) => isMuted && `
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: right;
    letter-spacing: 0.1px;
    color: #001221;
  `}
`;

const CallStatus = (props) => {
  const text = props.statusText !== "" ? props.statusText : props.status;

  return (
    <CallStatusContainer className="CallStatusContainer">
      <StatusMessage
        isMuted={Boolean(props.status?.toLowerCase() === 'muted')}
        held={props.isHeld}
        textColor={props.textColor}
        className="StatusMessage"
        status={props.status.toLowerCase()}
        isActiveCall={props.isActiveCall}
      >
        {`${text.charAt(0).toUpperCase()}${text.slice(1)}...`}
      </StatusMessage>
    </CallStatusContainer>
  );
};

CallStatus.propTypes = {
  status: PropTypes.string, //actual status for use in code.
  statusText: PropTypes.string, // translated string passed into status
  isActiveCall: PropTypes.bool,
  isHeld: PropTypes.bool
};

CallStatus.defaultProps = {
  status: 'connected',
  statusText: "",
  isActiveCall: false,
  isHeld: false
};

export default CallStatus;
